import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { CANCELOFFER_API } from "../../services/common/endpoints";
import { callQueryapi } from "../../services/http/callapi";
import CommonModalComponent from "../common/common-modal";
import PackAndSubscriptionsActionToggle from "./pack-and-subscriptions-action-toggle";
import ConfirmationModal from "./confirmation-modal";

const PackAndSubscriptionsAction = ({ passportList, item, refetch, index }) => {
  const navigate = useNavigate();
  const [popupShow, setPopupShow] = useState(false);
  const [checked, setChecked] = useState(true);
  const { t } = useTranslation()

  const toggleModal = () => {
    setPopupShow(!popupShow);
  };

  const packToggleOnOff = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [{}, CANCELOFFER_API, req],
      }),
    {
      onSuccess: (udata) => {
        const status = udata?.data?.status;
        try {
          const infomsg = udata?.data?.infomsg;
          const message = udata?.data?.message;
          if (status === "0") {
            navigate("/transactionstatus", {
              state: { isoffline: true, isuccess: true, info_message: infomsg, message: message },
            });
          } else {
            setChecked(!checked);
            navigate("/transactionstatus", {
              state: { isoffline: true, isuccess: false, info_message: infomsg, message: message },
            });
          }
        } catch (e) {
          setChecked(!checked);
          navigate("/transactionstatus", {
            state: { isoffline: true, isuccess: false, info_message: "", message: "" },
          });
        }
      },
      onError: () => {
        navigate("/transactionstatus", {
          state: { isoffline: true, isuccess: false, info_message: "", message: "" },
        });
      },
    }
  );

  const onOffTogglePacks = () => {
    const params = {
      offerid: item.offerId,
      isimmediatecancel: item.isCancelImmediate,
      isstopfallbackpurchase: item.isstopfallbackpurchase,
    };
    packToggleOnOff.mutate(params);
  };

  if (passportList != null && passportList != undefined && passportList != ""
    && passportList?.length > 0) {

    const isFound = passportList.some(element => {
      if (element?.offerid === item?.offerId) {
        return true;
      }
      return false;
    });

    if (isFound) {
      for (let a = 0; a < passportList?.length; a++) {
        if (passportList[a]?.offerid != null &&
          passportList[a]?.offerid != undefined &&
          passportList[a]?.offerid != "" &&
          passportList[a]?.offerid == item?.offerId) {
          return (
            <PackAndSubscriptionsActionToggle
              index={index}
              passportData={passportList[a]}
              item={item}
              onSuccess={refetch}
            />
          );
        }
      }
    }
    else {
      if (item?.iscancellable === "true") {
        return (
          <>
            <button
              className="custom_btn custom_btn_sm custom_btn_primary_outline text-initials"
              onClick={() => {
                setPopupShow(true);
              }}
            >
              {t('unsubscribe')}
            </button>

            <ConfirmationModal
              title={item?.oppopup?.deactivate_title}
              description={item?.oppopup?.deactivate_message}
              cancelText={item?.oppopup?.deactivate_btnclose}
              show={popupShow}
              submitText={item?.oppopup?.deactivate_btnunsub}
              toggleModal={() => {
                toggleModal();
              }}
              submit={onOffTogglePacks}
              loading={packToggleOnOff?.isLoading}
            />
          </>
        );
      }
    }
  } else {
    if (item?.iscancellable === "true") {
      return (
        <div className="action_grp">
          
          <button
            className="custom_btn custom_btn_sm custom_btn_primary_outline text-initials"
            onClick={() => {
              setChecked(false);
              setPopupShow(true);
            }}
          >
            {t('unsubscribe')}
          </button>
          <CommonModalComponent
            title={
              item?.oppopup?.deactivate_message ||
              item?.popup?.deactivate_message
            }
            description=""
            cancelText={t("Cancel")}
            show={popupShow}
            submitText={t("unsubscribe")}
            toggleModal={() => {
              setChecked(!checked);
              toggleModal();
            }}
            submit={onOffTogglePacks}
            loading={packToggleOnOff?.isLoading}
            success={packToggleOnOff?.isSuccess}
          />
        </div>
      );
    }
  }
};

export default PackAndSubscriptionsAction;
